import { NumberUtils, Logger } from "neo-common";
import { Strings } from "../../Common/Strings";
import { AppContext } from "../../Common/AppContext";

/**
 * Working with languages and texts. Get langugages based on rid, format and filter texts.
 * @class Languages
 */
export class Languages {
    // formats static variables
    static FormatMoney: string = "MONEY";

    // filters static variables
    static FilterNoZero: string = "NO_ZERO";

    /**
     * Return text based on rid.
     * @method getRid
     * @param rid string
     * @param ...value Array<string>
     * @return string
     */
    static getRid(rid: string, ...value: Array<string>): string {
        if (value != null && value.length > 0) {
            return Strings.getWithValues(rid, ...value);
        } else {
            return Strings.get(rid);
        }
    }

    /**
     * Format text based in ridType.
     * @method formatText
     * @param ridType string
     * @param text string
     * @return string
     */
    static formatText(ridType: string, text: string): string {
        switch (ridType) {
            case this.FormatMoney:
                return NumberUtils.valueToNumber(text, AppContext.gameConfiguration.ShowDecimalPlaces);
            default:
                if (DEBUG) {
                    this.log("WARNING unknow RidType: " + ridType);
                }
        }
        return text;
    }

    /**
     * Filter text based on RidFilter.
     * @method filtertext
     * @param ridFilter string
     * @param text string
     * @return string
     */
    static filterText(ridFilter: string, text: string): string {
        switch (ridFilter) {
            case this.FilterNoZero:
                if (parseFloat(text) <= 0) {
                    return "";
                } else {
                    return text;
                }
            default:
                if (DEBUG) {
                    this.log("WARNING unknow RidFilter: " + ridFilter);
                }
        }
        return text;
    }

    /**
     * Trace to browser console.
     * @method log
     * @param s string which will be traced to browser console.
     * @return void
     */
    static log(s: string): void {
        if (DEBUG) {
            Logger.debugGroup("Languages", s);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Utils/Languages.ts
 **/